import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import EmptySection from '../../../../../atoms/EmptySection'
import DynamicActionForm from '../../../../../organisms/DenaliActionPipeline/form/DynamicActionForm'
import SydModal from '../../../../../commonDesign/SydModal'
import SydButton from '../../../../../commonDesign/Button'
import SydModalActions from '../../../../../commonDesign/SydModal/SydModalActions'
import SubmitResultsPanel from './SubmitResultsPanel'

const useStyles = makeStyles(() => ({
  hint: {
    fontSize: 'var(--font-size-xs)',
    color: 'var(--text-color-subtle)',
    marginBottom: '12px'
  },
  formSurface: {
    border: '1px solid var(--color-neutral-200)',
    borderRadius: '8px',
    padding: '24px',
    backgroundColor: 'var(--color-neutral-050)',
    position: 'relative'
  },
  loadingOverlay: {
    position: 'absolute',
    inset: 0,
    backgroundColor: 'rgba(255,255,255,0.8)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    zIndex: 10
  },
  loadingText: {
    fontSize: 'var(--font-size-sm)',
    color: 'var(--text-color-subtle)',
    fontWeight: 500
  },
  modalBody: {
    padding: '16px'
  }
}))

function PreviewTab ({ template }) {
  const classes = useStyles()
  const [submitResult, setSubmitResult] = useState(null)
  const [submitting, setSubmitting] = useState(false)

  const definition = template?.definition
  const hasDefinition = !!definition?.fieldMapping?.groups?.length

  const handleMockSubmit = useCallback(async (args) => {
    setSubmitting(true)
    await new Promise(resolve => setTimeout(resolve, 800))
    setSubmitResult({
      args,
      argMapping: definition?.argMapping || {},
      actionPipelineCode: definition?.actionPipelineCode,
      timestamp: new Date().toISOString()
    })
    setSubmitting(false)
  }, [definition])

  const clearResult = useCallback(() => {
    setSubmitResult(null)
  }, [])

  if (!hasDefinition) {
    return (
      <EmptySection
        title='No Definition to Preview'
        description='Create a definition in the Edit tab first, then come back here to preview the form.'
      />
    )
  }

  return (
    <>
      <div className={classes.hint}>
        This renders the form as end users will see it. Submitting captures the pipeline args without executing.
      </div>
      <div className={classes.formSurface}>
        {submitting && (
          <div className={classes.loadingOverlay}>
            <span className={classes.loadingText}>Simulating submission&hellip;</span>
          </div>
        )}
        <DynamicActionForm
          actionTemplate={template}
          onSubmit={handleMockSubmit}
          onCancel={clearResult}
          variables={{}}
        />
      </div>

      <SydModal
        title='Mock Submission Result'
        open={!!submitResult}
        onClose={clearResult}
        size='medium'
        position='top'
      >
        <div className={classes.modalBody}>
          <SubmitResultsPanel result={submitResult} />
          <SydModalActions>
            <SydButton variant='primary' onClick={clearResult}>Close</SydButton>
          </SydModalActions>
        </div>
      </SydModal>
    </>
  )
}

PreviewTab.propTypes = {
  template: PropTypes.object.isRequired
}

export default PreviewTab
